import {
  ONLINEBOOK,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function onlineBook(state = initialState, action) {
  switch (action.type) {
    case ONLINEBOOK.handlers.fetch:
    case ONLINEBOOK.handlers.update:
    case ONLINEBOOK.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case ONLINEBOOK.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
